import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const SlideshowBanner = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [nextImageIndex, setNextImageIndex] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const bannerImages = [
    '/images/banner/wedding.png',
    '/images/banner/dinner.png',
    '/images/banner/image.png',
    // Add more banner images as needed
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentImageIndex((prev) => (prev === bannerImages.length - 1 ? 0 : prev + 1));
        setNextImageIndex((prev) => (prev === bannerImages.length - 1 ? 0 : prev + 1));
        setIsTransitioning(false);
      }, 1000); // Match this with the CSS transition duration
    }, 5000);

    return () => clearInterval(interval);
  }, [bannerImages.length]);

  return (
    <div className="relative h-screen overflow-hidden">
      {/* Current Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out"
        style={{
          backgroundImage: `url(${bannerImages[currentImageIndex]})`,
          opacity: isTransitioning ? 0 : 1
        }}
      />
      {/* Next Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${bannerImages[nextImageIndex]})`,
        }}
      />
      <div className="absolute inset-0 bg-black bg-opacity-50" />
      
      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl font-playfair mb-4">
            Divine Concepts by Margie
          </h1>
          <p className="text-xl md:text-2xl font-poppins mb-4">
            Event Styling & Hire Services
          </p>
          <p className="text-lg md:text-xl font-playfair italic mb-8">
            For Events That Speak Elegance
          </p>
          <Link
            to="/services"
            className="inline-block bg-gold-500 text-white font-poppins py-3 px-8 rounded-full hover:bg-gold-600 transition duration-300"
          >
            Explore Our Services
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SlideshowBanner;
